import React, { createContext, useCallback, useContext, useState } from "react";

import { BannerProps } from "components/Banner/Banner";

export enum BannerType {
  MISSED_PAYMENT = "Missed Payment",
  COMPANIES_LIMIT_REACHED = "Companies Limit Reached",
  ACCOUNT_EXPIRY_UPCOMING = "Upcoming Account Expiry",
  TEST_CLIENT = "Test Client",
}

interface BannerData {
  type: BannerType;
  index: number;
  value: Omit<BannerProps, "data-testid">;
}

interface BannerContextType {
  addBanner: (bannerData: BannerData) => void;
  removeBanner: (type: BannerType) => void;
  banners: BannerData[];
}

export const BannerContext = createContext<BannerContextType>(
  {} as BannerContextType
);

export const BannerContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [banners, setBanners] = useState<BannerData[]>([]);

  const addBanner = useCallback(
    (bannerData: BannerData) => {
      setBanners((prevBanners) =>
        [...prevBanners, bannerData].sort((a, b) =>
          a.index > b.index ? -1 : 1
        )
      );
    },
    [setBanners]
  );

  const removeBanner = useCallback(
    (type: BannerType) => {
      setBanners((prevBanners) => prevBanners.filter((x) => x.type !== type));
    },
    [setBanners]
  );

  return (
    <BannerContext.Provider
      value={{
        banners,
        addBanner,
        removeBanner,
      }}
    >
      {children}
    </BannerContext.Provider>
  );
};

export const useBannerContext = () => useContext(BannerContext);
